import React, { useEffect, useState } from "react";
import { DIVISIONS } from "@/data/divisions";

const SideRail = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const els = DIVISIONS.map((d) =>
      document.getElementById(`chapter-${d.slug}`)
    ).filter(Boolean);
    if (!els.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = els.indexOf(entry.target);
            if (idx >= 0) setActive(idx);
          }
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const go = (slug) => {
    const el = document.getElementById(`chapter-${slug}`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav className="side-rail">
      {DIVISIONS.map((d, i) => (
        <button
          key={d.slug}
          onClick={() => go(d.slug)}
          className={i === active ? "active" : ""}
          data-testid={`rail-${d.slug}`}
          style={i === active ? { color: d.accent } : undefined}
        >
          {d.index} — {d.name}
        </button>
      ))}
    </nav>
  );
};

export default SideRail;
